import React from 'react';
import Symbols from './symbols.svg';

const IconSymbols = () => (
    <Symbols />
);

export default IconSymbols;
